import React, { Component } from 'react';
import "./Assets/css/error.css";

export default class UsersNotFound extends Component {
    render() {
        return (
            <div className="usr">

            </div>
        );
    }
}
